import { ReactNodeViewRenderer as T } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { BLOCK_IMAGE_STYLES as _, FIGCAPTION_STYLES as F, FIGURE_CENTERED_STYLES as d, getFigureRightStyles as M, FIGURE_MOBILE_FULL_WIDTH_STYLES as b } from "../../constants/default-styles.mjs";
import { ImageNameEnum as h, ImageModeEnum as l } from "./image-enum.mjs";
import { convertStyleObjectToCss as u } from "../../utils/style-helpers.mjs";
import { CustomImage as B } from "./custom-image.mjs";
import { Image as C } from "./image.mjs";
import { getContainerWidthFromElement as R } from "./utils/get-container-width-from-element.mjs";
import { getImageAttrs as E } from "./utils/get-image-attrs.mjs";
import { getImageWithLinkHtml as k } from "./utils/get-image-with-link-html.mjs";
import { MOBILE_FULL_WIDTH_DATA_ATTRIBUTE as p, MOBILE_FULL_WIDTH_CLASSNAME as D } from "./constants/index.mjs";
import { mergeAttributes as H } from "../../node_modules/@tiptap/core/dist/index.mjs";
const K = C.extend({
  name: h.Block,
  addNodeView() {
    return T(B);
  },
  parseHTML() {
    return [
      {
        // skip ckeditor's legacy - tables https://app.shortcut.com/systeme/story/53281/he-has-a-problem-with-one-of-his-campaigns-in-the-classic-editor-where-he-can-no-longer-find-the-content-of-his-emails
        tag: "figure:not(.table)",
        getAttrs: (t) => {
          const i = t.querySelector("img"), o = t.querySelector("a"), r = t.querySelector("figcaption"), m = o == null ? void 0 : o.getAttribute("href"), a = E(i), s = R(t), e = t.getAttribute(p) === "true" || !!t.closest(`.${D}`);
          return {
            imageMode: t != null && t.style.float ? l.BlockRight : l.BlockCenter,
            href: m,
            containerWidth: s,
            caption: r == null ? void 0 : r.textContent,
            isMobileFullWidth: e,
            ...a
          };
        }
      }
    ];
  },
  renderHTML({
    HTMLAttributes: {
      caption: t,
      href: i,
      imageMode: o,
      alt: r,
      src: m,
      title: a,
      width: s,
      height: c,
      containerWidth: e,
      uploadingProps: I,
      isMobileFullWidth: S
    }
  }) {
    if (I) return ["span", { style: "display: none;" }];
    const n = { ..._ };
    s && c && (n.aspectRatio = `${s}/${c}`), e !== "auto" && (n.width = e);
    const f = H({
      src: m,
      alt: r,
      title: a,
      width: s,
      style: u(n)
    }), g = [k(f, { href: i })];
    t && g.push([
      "figcaption",
      {
        style: u(F)
      },
      t
    ]);
    const y = o === l.BlockCenter ? {
      ...d,
      ...e && { width: e }
    } : {
      ...M(!1),
      ...e && { width: e }
    }, L = {
      style: u(y)
    };
    if (S) {
      const A = [
        "figure",
        {
          ...L,
          [p]: "true"
        },
        ...g
      ];
      return [
        "div",
        ["head", {}, ["style", { type: "text/css" }, b]],
        A
      ];
    }
    return ["figure", L, ...g];
  }
});
export {
  K as BlockImage
};
